import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";
import Masonry from "masonry-layout/masonry";

export class AuwMasonry extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {

        }

    }

    __PageReady(){

        var masonryElement = this.$el.get( 0 );
        if(this.$el.find('.teaser-wrapper').length){
            masonryElement = this.$el.find('.teaser-wrapper').get(0);
        }
        this.msnry = new Masonry(masonryElement, {
            // options...
            itemSelector: '.teaser__item',
        });
        this.$el.find("img").on("load",this.reDoLayout.bind(this));



        //possibly hidden in tab/accordion
        if(!this.$el.is(":visible") && this.$el.parents('.auw_accortabs').length){
            this.$el.parents('.auw_accortabs').on('shown.bs.collapse shown.bs.tab', this.reDoLayout.bind(this));
        }
    }

    reDoLayout(){
        if(this.$el.is(":visible")) {
            this.msnry.layout();
        }
    }
}